var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-result',{attrs:{"icon":"success","title":"Hello Pix 充值成功","subTitle":""}},[_c('template',{slot:"extra"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }